import { SET_MAPPING } from '.';

export function setMapping({ name, path }) {
  return {
    type: SET_MAPPING,
    payload: { name, path }
  };
}